import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import CinemaList from '../present/CinemaList'
import { PROGRAM_CINEMAS, CLI_MULTICINEMA_MODE, PROGRAM_SELECTIONSDISPLAY_ITEMS, CLI_CINEMA_CLIENT_ID } from '../../../constants/state'


const mapStateToProps = state => ({
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    selectionsDisplayItems: getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS),
    cliMulticinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})


export default compose(
    connect(mapStateToProps, null),
    connect(null, null),
    toJS()
)(CinemaList)